export const LIST_ASSISTANT_REPORTS = 'LIST_ASSISTANT_REPORTS';
export const LIST_ASSISTANT_REPORTS_SUCCESS = 'LIST_ASSISTANT_REPORTS_SUCCESS';
export const LIST_ASSISTANT_REPORTS_FAILED = 'LIST_ASSISTANT_REPORTS_FAILED';
